import i18n from "../../../i18n";import { Trans } from "react-i18next";import { X, Trash2, UserX, ChevronRight, Check, AlertCircle } from "lucide-react";
import { cn } from "../../../lib/utils";

function ModalOverlay({ onClose, children }) {
  return (
    <div
      className="fixed inset-0 z-300 flex items-center justify-center p-4 bg-[#0a1230]/50 backdrop-blur-xs animate-in fade-in duration-200"
      onClick={onClose}>
      
      <div
        className={cn(
          "relative w-full max-w-[440px] bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60",
          "animate-in fade-in zoom-in-95 duration-200 font-sans"
        )}
        onClick={(e) => e.stopPropagation()}>
        
        {children}
      </div>
    </div>);

}

export function DeleteConfirmModal({ role, onConfirm, onCancel, loading }) {
  return (
    <ModalOverlay onClose={onCancel}>
      <button
        type="button"
        className="absolute top-3.5 right-3.5 h-9 w-9 grid place-items-center rounded-xl per-file-hint hover:bg-workspace/60 hover:text-primary transition"
        onClick={onCancel}
        aria-label={i18n.t("formActions.close")}>
        
        <X className="h-5 w-5" />
      </button>
      <div className="px-6 pt-8 pb-6 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-error/10">
          <Trash2 className="h-8 w-8 text-error" />
        </div>
        <h2 className="text-xl font-bold text-foreground mb-2"><Trans i18nKey="formActions.delete3" />{role.name}&rsquo;?</h2>
        <p className="text-sm per-file-hint leading-relaxed mb-4">
          <Trans i18nKey="validation.thisActionCannotBeUndone" />
          <br />
          <Trans i18nKey="roles.theRole" /><strong className="text-foreground">{role.name}</strong><Trans i18nKey="roles.willBePermanentlyDeleted" />
        </p>
        <div className="flex items-start gap-2 rounded-xl border border-success/30 bg-success/5 px-3.5 py-2.5 text-left text-[13px] text-success mb-6">
          <Check className="h-4 w-4 shrink-0 mt-0.5" />
          <span><Trans i18nKey="roles.noUsersAreCurrentlyAssignedToThisRole" /></span>
        </div>
        <div className="flex flex-col-reverse sm:flex-row gap-2.5 justify-center">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="h-11 px-5 rounded-xl border border-(--color-text-border) text-sm font-semibold text-foreground hover:bg-workspace/40 transition disabled:opacity-60">
            <Trans i18nKey="formActions.cancel" />
          
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="h-11 px-5 rounded-xl bg-error text-white text-sm font-semibold hover:opacity-90 transition shadow-[0_8px_20px_-8px_rgba(220,38,38,0.5)] disabled:opacity-60">
            
            {loading ? "Deleting..." : "Delete Role"}
          </button>
        </div>
      </div>
    </ModalOverlay>);

}

export function DeleteBlockedModal({ role, onClose }) {
  return (
    <ModalOverlay onClose={onClose}>
      <button
        type="button"
        className="absolute top-3.5 right-3.5 h-9 w-9 grid place-items-center rounded-xl per-file-hint hover:bg-workspace/60 hover:text-primary transition"
        onClick={onClose}
        aria-label={i18n.t("formActions.close")}>
        
        <X className="h-5 w-5" />
      </button>
      <div className="px-6 pt-8 pb-6 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <UserX className="h-8 w-8 text-primary" />
        </div>
        <h2 className="text-xl font-bold text-foreground mb-2"><Trans i18nKey="validation.canTDelete2" />{role.name}&rsquo;</h2>
        <p className="text-sm per-file-hint leading-relaxed mb-4">
          <strong className="text-foreground">{role.usersAssigned} <Trans i18nKey="common.employees" /></strong> <Trans i18nKey="roles.areStillAssignedToThisRole" />
          <br />
          <Trans i18nKey="formActions.removeThisRoleFromThemOrReassignFirst" />
        </p>
        <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3.5 py-2.5 text-left text-[13px] text-amber-800 mb-6">
          <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
          <span><Trans i18nKey="roles.youCanViewTheListOfAssignedEmployees" /></span>
        </div>
        <div className="flex flex-col-reverse sm:flex-row gap-2.5 justify-center">
          <button
            type="button"
            onClick={onClose}
            className="h-11 px-5 rounded-xl border border-(--color-text-border) text-sm font-semibold text-foreground hover:bg-workspace/40 transition">
            <Trans i18nKey="formActions.close" />
          
          </button>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center gap-1.5 h-11 px-5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-accent transition shadow-[0_8px_20px_-8px_rgba(30,51,131,0.5)]">
            <Trans i18nKey="formActions.viewAssignedEmployees" />
            
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </ModalOverlay>);

}

export function UnsavedModal({ onDiscard, onStay }) {
  return (
    <ModalOverlay onClose={onStay}>
      <div className="px-6 py-5">
        <h2 className="text-lg font-bold text-foreground mb-2"><Trans i18nKey="formActions.discardChanges" /></h2>
        <p className="text-sm per-file-hint leading-relaxed mb-5">
          <Trans i18nKey="roles.youHaveUnsavedChangesIfYouLeaveNow" />
        </p>
        <div className="flex justify-end gap-2.5">
          <button
            type="button"
            onClick={onStay}
            className="h-10 px-4 rounded-xl border border-(--color-text-border) text-sm font-semibold text-foreground hover:bg-workspace/40 transition">
            <Trans i18nKey="formActions.stay" />
          
          </button>
          <button
            type="button"
            onClick={onDiscard}
            className="h-10 px-4 rounded-xl bg-error text-white text-sm font-semibold hover:opacity-90 transition">
            <Trans i18nKey="formActions.discard" />
          
          </button>
        </div>
      </div>
    </ModalOverlay>);

}

export function ZeroPermsModal({ onSave, onCancel }) {
  return (
    <ModalOverlay onClose={onCancel}>
      <div className="px-6 py-5">
        <h2 className="text-lg font-bold text-foreground mb-2"><Trans i18nKey="roles.noPermissionsSelected" /></h2>
        <p className="text-sm per-file-hint leading-relaxed mb-5">
          <Trans i18nKey="roles.thisRoleGrants" /> <strong className="text-foreground"><Trans i18nKey="validation.noAccess" /></strong> <Trans i18nKey="roles.toAnyServiceOrModuleUsersAssignedTo" />
        
        </p>
        <div className="flex justify-end gap-2.5">
          <button
            type="button"
            onClick={onCancel}
            className="h-10 px-4 rounded-xl border border-(--color-text-border) text-sm font-semibold text-foreground hover:bg-workspace/40 transition">
            <Trans i18nKey="formActions.goBack2" />
          
          </button>
          <button
            type="button"
            onClick={onSave}
            className="h-10 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-accent transition">
            <Trans i18nKey="formActions.saveAnyway" />
          
          </button>
        </div>
      </div>
    </ModalOverlay>);

}
